import styled from 'styled-components'

const SixtyThirtyColumns = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));

  @media screen and (min-width: 940px) {
    grid-template-columns: 2fr 1fr;
  }
`

export default SixtyThirtyColumns
